/* eslint-disable sort-keys */
import { List } from '@ahmdigital/ui';
import React from 'react';

export const FIELD_NAMES = {
  DEPARTURE_DATE: 'departureDate',
  DESTINATIONS: 'destinations',
  IS_MEMBER: 'isMember',
  RETURN_DATE: 'returnDate',
  WHEN: 'when',
  WHERE: 'where',
  WHO: 'who',
  PROMO_CODE: 'promoCode',
  RESIDENT: 'resident',
  TRAVELLER_AGE_1: 'travelerAge_1',
  TRAVELLER_AGE_2: 'travelerAge_2',
  TRAVELLER_AGE_3: 'travelerAge_3',
  TRAVELLER_AGE_4: 'travelerAge_4',
  TRAVELLER_AGE_5: 'travelerAge_5',
  TRAVELLER_AGE_6: 'travelerAge_6',
  TRAVELLER_AGE_7: 'travelerAge_7',
  TRAVELLER_AGE_8: 'travelerAge_8',
  TRAVELLER_AGE_9: 'travelerAge_9',
  TRAVELLER_AGE_10: 'travelerAge_10',
};

export const WHEN_FIELD_NAMES = [FIELD_NAMES.DEPARTURE_DATE, FIELD_NAMES.RETURN_DATE];

export const WHO_FIELD_NAMES = [
  FIELD_NAMES.PROMO_CODE,
  FIELD_NAMES.TRAVELLER_AGE_1,
  FIELD_NAMES.TRAVELLER_AGE_2,
  FIELD_NAMES.TRAVELLER_AGE_3,
  FIELD_NAMES.TRAVELLER_AGE_4,
  FIELD_NAMES.TRAVELLER_AGE_5,
  FIELD_NAMES.TRAVELLER_AGE_6,
  FIELD_NAMES.TRAVELLER_AGE_7,
  FIELD_NAMES.TRAVELLER_AGE_8,
  FIELD_NAMES.TRAVELLER_AGE_9,
  FIELD_NAMES.TRAVELLER_AGE_10,
  FIELD_NAMES.RESIDENT,
];

export const SUGGESTED_DESTINATIONS = [
  {
    label: 'Indonesia (Bali)',
    value: 'Indonesia (Bali)',
    code: '510-101-100',
  },
  {
    label: 'The United States of America (USA)',
    value: 'United States of America (USA)',
    code: '507-236-288',
  },
  {
    label: 'New Zealand',
    value: 'New Zealand',
    code: '1006-61',
  },
  {
    label: 'Thailand',
    value: 'Thailand',
    code: '509-166',
  },
  {
    label: 'Europe',
    value: 'Europe',
    code: '508-327',
  },
  {
    label: 'Worldwide',
    value: 'Worldwide',
    code: '507-322-274',
  },
] as const;

export const ACCORDION_ITEMS = [
  {
    title: 'Spending 20% or more of your trip in the Americas or Africa?',
    body: (
      <>
        If you’ll be spending 20% or more of your trip in the Americas or Africa, you must select “Worldwide” or enter
        and select a country of the Americas or Africa (no matter where you are going before or after).
      </>
    ),
  },
  {
    title: 'Taking a cruise?',
    body: (
      <List variant="inside">
        <li>
          In Australia (e.g. on the Murray River) or in Australian coastal waters (e.g. a Kimberley Cruise) - Please
          choose or enter “Australia”
        </li>
        <li>
          From a port in Australia to another port or ports in Australia without any stopover at a port outside of
          Australia (e.g. a ’Sampler Cruise’, a cruise from Sydney to Brisbane) - Please choose or enter “Domestic
          Cruise”.
        </li>
        <li>
          Overseas (e.g. a European river cruise, Caribbean cruise or a cruise from Hong Kong to Sydney) or from a port
          in Australia to another port or ports outside Australia (e.g. Sydney/Singapore) - Please choose or enter the
          main area or destination/country based on where you will spend the most time on your trip.
        </li>
      </List>
    ),
  },
  {
    title: 'Travelling to multiple countries in Europe?',
    body: (
      <>
        If you are travelling to multiple countries in Europe, you can select the country you are spending the most of
        your time, or if you are spending your time equally across multiple different European countries you can select
        “Europe”.
      </>
    ),
  },
];

// matches one or more characters not including '(', followed by a space, an opening parenthesis '(', one or more characters not including ')', and an optional closing parenthesis ')'
export const PARENTHESIS_MATCH_REGEX = /^([^(]+)\s\(([^)]+)\)?$/;

export const DEFAULT_DATE_FORMAT = 'dd/mm/yy';

export const SESSION_STORAGE_KEYS = {
  FORMIK_STATE: 'travel-widget-state',
  TRAVELLER_COUNT: 'travel-widget-amount-of-travellers',
};
